//邮箱正则判断
let reg_email = /^[a-zA-Z0-9.!#$%&#$%&amp; '*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// 输入框判断
$('.pay_box .input_box input').blur(function(){
    if($(this).parent().hasClass('email_box')){
        if(!$(this).val()){
            $(this).next().html(i18n[lang]['input_email_tips_1']);
            return false;
        }
        if(!reg_email.test($(this).val())){
            $(this).next().html(i18n[lang]['input_email_tips_2']);
            return false;
        }
        $(this).next().html('');
    }
    if($(this).parent().hasClass('first_name')){
        if(!$(this).val()){
            $(this).next().html(i18n[lang]['input_first_name_tips']);
            return false;
        }
        $(this).next().html('');
    }
    if($(this).parent().hasClass('last_name')){
        if(!$(this).val()){
            $(this).next().html(i18n[lang]['input_last_name_tips']);
            return false;
        }
        $(this).next().html('');
    }
})
// 语言切换
$('.lang.select_box div ul li').click(function(){
    var new_lang=$(this).attr('lang')
    i18n_load(new_lang, function() {
        lang = new_lang;
        if($('.main.container').css('display')!='none'){
            get_product(product_list,coupon,countryCode,currency,lang,'',order_id)
        }
        modify_lang()
    })
})
// 下拉切换
$(document).click(function(){
    $('.select_box .select_main').hide()
})
$('.select_box span').click(function(e){
    e.stopPropagation()
    var $main = $(this).siblings('.select_main')
    var isVisible = $main.css('display') !== 'none'
    $('.select_box .select_main').hide()
    if(!isVisible){
        $main.css('display','block')
        // 打开时清空搜索框并重置列表
        var $input = $main.find('.select_search input')
        $input.val('')
        $main.find('ul li').show()
        $input.focus()
    }
})
$('.select_box div ul').on('click','li',function(e){
    e.stopPropagation()
    $(this).parents('.select_box').children('span').html($(this).html())
    $(this).addClass('active').siblings().removeClass('active')
    $(this).parents('.select_main').hide()
})
// 下拉搜索过滤
$(document).on('input', '.select_box .select_search input', function(e){
    e.stopPropagation()
    var keyword = $(this).val().toLowerCase()
    $(this).closest('.select_main').find('ul li').each(function(){
        var text = $(this).text().toLowerCase()
        $(this).toggle(text.indexOf(keyword) !== -1)
    })
})
$('.select_box .select_search input').click(function(e){
    e.stopPropagation()
})
// 失败
function fail(){
    $('.mask_loading').hide()
    window.scroll(0,0)
    $('.main').hide()
    $('.fail').addClass('active')
    var time_num=5;
    var time;
    time=setInterval(function(){
        time_num--;
        $('.fail .tips .num').html(time_num)
        if (time_num == 0) {
            if(location.host.split('.')[0]=='order'){
                location.href=$('.fail .btn').attr('href')
            }
            clearInterval(time);
        }
    },1000);
}
//获取地址栏参数
function getQueryVariable(variable)
{
       var params = new URLSearchParams(window.location.search);
       return params.has(variable) ? params.get(variable) : false;
}
// 时间戳转换
function getdate(time) {
    var now=new Date(time*1000)
    var y=now.getFullYear()
    var m=now.getMonth()+1
    var d=now.getDate()
    return y+'-'+(m < 10 ? "0" + m : m)+'-'+(d < 10 ? "0" + d : d)
}
// 请求产品获取信息
var product_id=getQueryVariable('product_id')
var quantity=getQueryVariable('quantity')?getQueryVariable('quantity'):1
var coupon=getQueryVariable('coupon')?getQueryVariable('coupon'):undefined
var source=getQueryVariable('source')?getQueryVariable('source'):''
var countryCode=''
var stateCode=''
var currency=''
var order_id=getQueryVariable('finish')?getQueryVariable('finish'):''
var pay_type=''
var is_test=getQueryVariable('is_test')=='1' || location.hostname.indexOf('localhost')!==-1 || location.hostname.indexOf('sandbox')!==-1 ? 1 : 0
var product_list=[];
var is_ga_view_item=true
var ga_items=[];
var ga_total_price;
var ga_coupon;
function get_product(product_list,coupon,countryCode,currency,lang,buy_info,order_id){
    $('.main>.main_loading').addClass('active')
    $.post(
        '/wp-json/checkout/product',
        {
            product_list:product_list,
            coupon:coupon,
            countryCode:countryCode,
            stateCode:stateCode,
            currency:currency,
            languages:lang,
            buy_info:buy_info,
            order_id:order_id,
            is_test:is_test,
            source:source,
        },
        function(res){
            $('.mask_loading').hide()
            $('.main>.main_loading').removeClass('active')
            if(res.error==0){
                if(is_buy){
                    is_buy=false
                    $('.main>.main_loading').addClass('active')
                    if(payment_platform=='v5'){
                        location.href=res.checkout_url
                    }else if(payment_platform=='adyen'){
                        window.order_id=res.order_id
                        adyen_init(res.checkout_url)
                    }
                    return false;
                }
                adyen_destroy()
                // 清空状态
                $('.product_list .scroll_box').html('')
                $('.product_box .coupon_price').removeClass('active')
                $('.product_box .coupon_box .apply').removeClass('active')

                window.countryCode=countryCode=res.countryCode
                window.currency=currency=res.currency
                window.lang=lang=res.languages
                window.order_id=res.order_id
                ga_items=[]
                ga_coupon=res.coupon['name']
                i18n_load(lang, function() {
                    modify_lang()
                    var is_close=''
                    if(res.product.length>1){
                        is_close='<i class="close"></i>'
                    }
                    var is_free_product=false;
                    for(var i=0;i<res.product.length;i++){
                        var price=res.product[i]['price']
                        var sale_price=res.product[i]['sale_price']
                        if(sale_price && sale_price!='0.00' && sale_price!='0'){
                            var price_html=`<span class="sale_price">${sale_price+' '+currency}</span><del>${price+' '+currency}</del>`;
                        }else{
                            var price_html=`<span>${price+' '+currency}</span>`;
                        }
                        if(res.product[i]['free_day']>0){
                            is_free_product=true
                        }
                        $('.product_list .scroll_box').append(`
                            <div class="product_info flex_box" product_id="${res.product[i]['id']}" ${res.product[i]['free_day']>0?'free_product="1"':''}>
                                <span>${res.product[i]['name']}</span>
                                <span>${res.product[i]['quantity']}</span>
                                <span>${price_html}</span>
                                ${is_close}
                            </div>    
                        `)
                        ga_items.push({
                            'item_id':res.product[i]['id'],
                            'item_name':res.product[i]['name'],
                            'price':res.product[i]['total_price']*1,
                            'discount':res.product[i]['coupon_price']*1,
                            'quantity':res.product[i]['quantity']*1,
                            'coupon':ga_coupon,
                        })
                    }
                    // 如果有免费产品，付费产品的删除按钮隐藏
                    if(is_free_product){
                        $('.product_info:not([free_product="1"]) .close').remove()
                    }
                    if($('.product_list .sale_price').length){
                        $('.product_box .coupon_box .apply span').html(res.coupon.name + " "+ i18n[lang]['has_been_applied']).parent().siblings().removeClass('active')
                        $('.product_box .coupon_price').addClass('active')
                        $('.product_box .coupon_box .apply').addClass('active')
                    }
                    $('.product_box .product_price span:last-child').html(res.product_price+' '+currency)
                    if(res.coupon.type=='fixed_cart'){
                        $('.product_box .coupon_price span:last-child').html('- '+res.coupon_price+' '+currency)
                    }else{
                        $('.product_box .coupon_price span:last-child').html('- '+res.coupon_price+' '+currency+' ('+res.coupon.amount+'% OFF)')
                    }
                    $('.product_box .tax_price span:last-child').html(res.tax_price+' '+currency+' ('+res.tax+'%)')
                    $('.product_box .total_price span:last-child').html(res.total_price+' '+currency)
                    // 国家渲染
                    $('.pay_box .billing_box .country ul').html('')
                    for (var key in res.countries) {
                        if(key==res.countryCode){
                            $('.pay_box .billing_box .country span').html(res.countries[key])
                        }
                        $('.pay_box .billing_box .country ul').append('<li value="'+key+'">'+res.countries[key]+'</li>')
                    }
                    // 州渲染
                    $('.pay_box .billing_box .countries_states ul').html('')
                    if(res.countries_states){
                        $('.pay_box .billing_box .countries_states').show()
                        var stateRestored = false;
                        for (var key in res.countries_states) {
                            var isActive = key == stateCode;
                            $('.pay_box .billing_box .countries_states ul').append('<li value="'+key+'"'+(isActive?' class="active"':'')+'>'+res.countries_states[key]+'</li>')
                            if(isActive){
                                $('.pay_box .billing_box .countries_states span').html(res.countries_states[key])
                                stateRestored = true;
                            }
                        }
                        // 如果当前 stateCode 不在列表中，重置显示
                        if(!stateRestored){
                            stateCode = '';
                            $('.pay_box .billing_box .countries_states span').html(i18n[lang]['states'])
                        }
                    }else{
                        stateCode = '';
                        $('.pay_box .billing_box .countries_states').hide()
                    }
                    // 货币修改
                    $('.product_box .currency_box span').html(currency)
                    $('.product_box .currency_box ul li[value="'+currency+'"]').addClass('active').siblings().removeClass('active')
                    // 支付类型
                    $('.pay_type>span').removeClass('active')
                    if(res.interval!='lifetime' && res.interval!=''){
                        $('.pay_box .pay_type.renew').children('span').eq(0).addClass('active')
                        $('.pay_box .pay_type.renew').addClass('active').siblings().removeClass('active');
                    }else{
                        $('.pay_box .pay_type.lifetime').children('span').eq(0).addClass('active')
                        $('.pay_box .pay_type.lifetime').addClass('active').siblings().removeClass('active');
                    }
                    if(pay_type){
                        $('.pay_box .pay_type.active>span[value="'+pay_type+'"]').addClass('active').siblings().removeClass('active')
                    }
                    ga_total_price=res.total_price*1
                    if(is_ga_view_item){
                        is_ga_view_item=false
                        // 查看
                        dataLayer.push({ecommerce:null});
                        dataLayer.push({
                            event:'view_item',
                            ecommerce:{
                                currency: window.countryCode,
                                value: ga_total_price,
                                item_brand: payment_platform,
                                items:ga_items
                            }
                        })
                        // 插入购物车
                        dataLayer.push({ecommerce:null});
                        dataLayer.push({
                            event:'add_to_cart',
                            ecommerce:{
                                currency: window.countryCode,
                                value: ga_total_price,
                                item_brand: payment_platform,
                                items:ga_items
                            }
                        })
                    }
                });
            }else{
                fail()
                i18n_load(lang, function() {
                    modify_lang()
                })
            }
        }
    ).error(function(){
        fail()
        i18n_load(lang, function() {
            modify_lang()
        })
    })
}
if(order_id){
    try{
        order_id = atob(order_id)
        if(!order_id) throw new Error('解密结果为空')
        console.log(order_id);
        get_order(order_id)
    }catch(e){
        console.error('order_id 解密失败:', e)
        fail()
    }
}else{
    // 判断值
    if(product_id){
        product_id=product_id.split(',')
        quantity=String(quantity).split(',')
        for(var i=0;i<product_id.length;i++){
            product_list.push({
                'product_id':product_id[i],
                'quantity':quantity[i]?quantity[i]:1
            })
        }
        // V5
        // get_product(product_list,coupon,'RU','RUB',lang,'',order_id)
        // 正常
        get_product(product_list,coupon,'','',getBrowserLanguage(),'',order_id)
    }else{
        fail()
    }
}
function get_order(order_id){
    $.post(
        '/wp-json/checkout/get_order',
        {
            'order_id':order_id
        },
        function(res){
            console.log(res)
            $('.mask_loading').hide()
            if(res.error==0){
                if(res.status!=2){
                    if(res.status==-1){
                        for(var i=0;i<res.product.length;i++){
                            product_list.push({
                                'product_id':res.product[i].product_id,
                                'quantity':res.product[i].quantity?res.product[i].quantity:1
                            })
                        }
                        coupon=res.coupon
                        get_product(product_list,coupon,'','',lang,'',order_id)
                        return false;
                    }
                    if(res.status==0){
                        for(var i=0;i<res.product.length;i++){
                            product_list.push({
                                'product_id':res.product[i].product_id,
                                'quantity':res.product[i].quantity?res.product[i].quantity:1
                            })
                        }
                        coupon=res.coupon
                        countryCode=res.country
                        currency=res.currency
                        lang=res.language
                        modify_lang()
                        $('.pay_box .email_box input').val(res.email)
                        $('.pay_box .first_name input').val(res.first_name)
                        $('.pay_box .last_name input').val(res.last_name)
                        pay_type=res.payment_method
                        get_product(product_list,coupon,'','',lang,'',order_id)
                        return false;
                    }
                    if(res.status==1){
                        $('.mask_loading').show()
                        setTimeout(function(){
                            get_order(order_id)
                        },1000)
                        return false;
                    }
                    if(res.status==3){
                        fail()
                        return false;
                    }
                    return false;
                }
                $('.main').hide()
                $('.completed').addClass('active')
                $('.completed .order .order_id').html(order_id)
                $('.completed .order .order_date').html(getdate(res.date))
                $('.completed .order .order_email').html(res.email)
                var ga_purchase_items=[]
                for(var i=0;i<res.productList.length;i++){
                    $('.completed .product>div').append(`
                        <p class="drop flex_box"><span class="name bold">${res.productList[i].productName}</span></p>
                        <p class="flex_box"><span class="bold">${i18n[lang]['quatity']}</span> <span class="quatity">${res.productList[i].quantity}</span></p> 
                    `)
                    ga_purchase_items.push({
                        'item_id':res.productList[i]['productId'],
                        'item_name':res.productList[i]['productName'],
                        'price':res.productList[i]['price']*1,
                        'quantity':res.productList[i]['quantity']*1,
                        'coupon':res.productList[i]['coupon'],
                    })
                }
                $('.completed .product>div').append(`
                    <p class="flex_box"><span class="bold">${i18n[lang]['total_price']}</span> <span class="price">${res.price} ${res.currency}</span></p>   
                `)
                // 插入购物车
                dataLayer.push({ecommerce:null});
                dataLayer.push({
                    event:'purchase',
                    ecommerce:{
                        currency: res.currency,
                        value: res.price*1,
                        transaction_id:res.order_id,
                        coupon: ga_purchase_items[0]['coupon'],
                        tax:res.tax_price*1,
                        item_brand: res.platform,
                        items:ga_purchase_items
                    }
                })
            }else{
                fail()
            }
        }
    ).error(function(){
        fail()
    })
}
// 折扣码
$('.product_box .coupon_box>span').click(function(){
    $(this).siblings('.input').addClass('active').siblings().removeClass('active')
})
$('.product_box .coupon_box .close').click(function(){
    $('.product_box .coupon_box>span').addClass('active').siblings().removeClass('active')
})
// 去除折扣
$('.product_box .coupon_box .apply .close').click(function(){
    $('.product_box .coupon_box>span').addClass('active').siblings().removeClass('active')
    coupon=''
    get_product(product_list,coupon,countryCode,currency,lang,'',order_id)
})
// 添加折扣码
$('.product_box .coupon_box .input .btn').click(function(){
    if(!$('.product_box .coupon_box .input input').val()){
        return false;
    }
    coupon=$('.product_box .coupon_box .input input').val()
    get_product(product_list,coupon,countryCode,currency,lang,'',order_id)
})
// 货币切换（span 只显示货币代码，不显示完整名称）
$('.currency_box.select_box div ul').on('click','li',(function(){
    currency=$(this).attr('value')
    $('.currency_box.select_box>span').html(currency)
    get_product(product_list,coupon,countryCode,currency,lang,'',order_id)
}))

// 国家切换
$('.country.select_box div ul').on('click','li',(function(){
    countryCode=$(this).attr('value')
    stateCode=''
    $('.pay_box .billing_box .country>span').removeClass('input_error').siblings('.input_tips').remove()
    get_product(product_list,coupon,countryCode,currency,lang,'',order_id)
}))
// 州点击切换
$('.countries_states.select_box div ul').on('click','li',function(){
    stateCode=$(this).attr('value')
    $('.pay_box .billing_box .countries_states>span').removeClass('input_error').siblings('.input_tips').remove()
    get_product(product_list,coupon,countryCode,currency,lang,'',order_id)
})
// 支付类型选择
$('.pay_box .pay_type>span').click(function(){
    $(this).addClass('active').siblings().removeClass('active')
})
// 购买链接
var is_buy=false
$('.pay_box .payment_box .btn').click(function(){
    var email=$('.pay_box .email_box input')
    var first_name=$('.pay_box .first_name input')
    var last_name=$('.pay_box .last_name input')
    if(!reg_email.test(email.val())){
        email.next().html(i18n[lang]['input_email_tips_2']);
        return false;
    }
    var country_span=$('.pay_box .billing_box .country>span')
    if(!countryCode){
        country_span.addClass('input_error').siblings('.input_tips').remove()
        country_span.after('<p class="input_tips">'+i18n[lang]['input_country_tips']+'</p>')
        return false;
    }else{
        country_span.removeClass('input_error').siblings('.input_tips').remove()
    }
    if($('.pay_box .billing_box .countries_states').css('display')!='none'){
        var state_span=$('.pay_box .billing_box .countries_states>span')
        if(!stateCode){
            state_span.addClass('input_error').siblings('.input_tips').remove()
            state_span.after('<p class="input_tips">'+i18n[lang]['input_state_tips']+'</p>')
            return false;
        }else{
            state_span.removeClass('input_error').siblings('.input_tips').remove()
        }
    }
    if(!first_name.val()){
        first_name.next().html(i18n[lang]['input_first_name_tips']);
        return false;
    }
    if(!last_name.val()){
        last_name.next().html(i18n[lang]['input_last_name_tips']);
        return false;
    }
    is_buy=true
    var userProofUrl;
    if(coupon){
        userProofUrl=location.href.split('?')[0]+'?product_id='+product_id+'&coupon='+coupon+'&quantity='+quantity
    }else{
        userProofUrl=location.href.split('?')[0]+'?product_id='+product_id+'&quantity='+quantity
    }
    var json={
        'order_id':order_id,
        'email':email.val(),
        'first_name':first_name.val(),
        'last_name':last_name.val(),
        'state':stateCode,
        'pay_type':$('.pay_type>span.active').attr('value')? $('.pay_type>span.active').attr('value'):'',
        'redirectUrl':location.href.split('?')[0],
        'userProofUrl':userProofUrl,
        'lang':lang,
    }
    if(getQueryVariable('passthrough')){
        json['passthrough']=JSON.parse(url_base64_decode(getQueryVariable('passthrough')))
    }
    // 插入购物车
    dataLayer.push({ecommerce:null});
    dataLayer.push({
        event:'begin_checkout',
        ecommerce:{
            currency: window.countryCode,
            value: ga_total_price,
            coupon: ga_coupon,
            item_brand: payment_platform,
            items:ga_items
        }
    })
    get_product(product_list,coupon,countryCode,currency,lang,json,order_id)
})
// 删除产品
$('.product_list').on('click','.product_info>.close',function(){
    var product_id=$(this).parent().attr('product_id')
    product_list = product_list.filter(function(item) {
        return item.product_id !== product_id;
    });
    get_product(product_list,coupon,countryCode,currency,lang,'',order_id)
})
// 判断回退
document.addEventListener('DOMContentLoaded', (event) => {
    if (window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
        console.log("页面是通过后退或前进按钮加载的");
        // 在这里执行重新加载或其他操作
        location.reload();
    }
});
// 解码 Base64 字符串
function url_base64_decode(str) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    const padLength = 4 - (str.length % 4);
    if (padLength < 4) {
        str += '='.repeat(padLength);
    }
    try {
        const decoded = atob(str);
        const uriEncoded = Array.from(decoded).map(char => '%' + char.charCodeAt(0).toString(16).padStart(2, '0')).join('');
        return decodeURIComponent(uriEncoded);
    } catch (e) {
        console.error('Base64 decoding error:', e);
        return '';
    }
};
// tips弹窗
$('.tips_mask .close').click(function(){
    $('.tips_mask').removeClass('active')
})
$(document).on('click','.terms_click',function(){
    $('.tips_mask').addClass('active')
    $('.terms_box').addClass('active').siblings().removeClass('active')
})
$(document).on('click','.subscription_click',function(){
    $('.tips_mask').addClass('active')
    $('.subscription_box').addClass('active').siblings().removeClass('active')
})
// 获取语言
function getBrowserLanguage() {
    const lang = navigator.language || navigator.userLanguage || 'en';
    if (lang.toLowerCase() === 'zh-tw') return 'zh-TW';
    return lang.split('-')[0];
}
